import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { WorkflowFamily } from "./workflow-family";
import { WorkflowType } from "./workflow-type";
import { DbWorkflowDefinitionInputFilterInfos } from "./db-workflow-definition-input-filter-infos";
import { WorkflowEngine } from "./workflow-engine";
import { immerable } from "immer";

export class DbWorkflowDefinitionInfos extends DbMongoBaseInfos {
  [immerable] = true;

  isLegacy: boolean = false;
  isAsync: boolean = false;
  isPlayableManually: boolean = false;
  platformIds: number[] | null = [];
  family: WorkflowFamily | null = null;
  type: WorkflowType | null = null;
  name: string | null = null;
  description: string | null = null;
  daletWorkflowName: string | null = null;
  daletWorkflowId: string | null = null;
  daletWorkflowKey: string | null = null;
  licenseSlots: number | null = null;
  outputStorageId: number | null = null;
  userIdReferenceApi: number | null = null;
  filter: DbWorkflowDefinitionInputFilterInfos | null = null;
  engine: WorkflowEngine | null = null;

  constructor(init?: Partial<DbWorkflowDefinitionInfos>) {
    super();
    Object.assign(this, init);
  }
}
